import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'

export const theme = {
  rankGradient: 'linear-gradient(90deg, #10B981 0.03%, #059669 100%)',
  medalNumberTop: '-4px',
} as const

export const resources = {
  homeBg: '/images/novelsprig/home-bg.svg',
  spikeletL: '/images/novelsprig/ranking/spikelet_l.svg',
  spikeletR: '/images/novelsprig/ranking/spikelet_r.svg',
  goldMedal: '/images/novelsprig/ranking/rank-badge-gold.svg',
  silverMedal: '/images/novelsprig/ranking/rank-badge-silver.svg',
  bronze: '/images/novelsprig/ranking/rank-badge-bronze.svg',
  medal: '/images/novelsprig/ranking/rank-badge-default.svg',
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
